import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 9000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  padding: 24px 16px;
`;

export const Modal = styled.div`
  background: #fff;
  border-radius: 10px;
  width: 100%;
  max-width: 580px;
  padding: 26px 28px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  position: relative;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.18);
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
`;

export const ModalTitle = styled.h2`
  color: #1b2b3a;
  font-size: 1.15rem;
  font-weight: 700;
  margin: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  color: #888;
  font-size: 1.15rem;
  line-height: 1;
  cursor: pointer;
  padding: 2px;

  &:hover { color: #333; }
`;

export const StatusLine = styled.p`
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.88rem;
  color: #333;
`;

export const Dot = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #2f80ed;
  flex-shrink: 0;
`;

export const WhenLine = styled.p`
  margin: 0;
  font-size: 0.92rem;
  font-weight: 700;
  color: #1b2b3a;
`;

export const Hint = styled.p`
  margin: 0;
  font-size: 0.8rem;
  color: #7a8794;
`;

export const ActionRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 14px;
`;

export const SecondaryButton = styled.button`
  flex: 1;
  padding: 10px 18px;
  border-radius: 6px;
  border: 1.5px solid #26A9B6;
  background: #fff;
  color: #1b3a6b;
  font-size: 0.88rem;
  cursor: pointer;

  &:hover { background: #f0fbfc; }
`;

export const JoinButton = styled.button`
  flex: 1;
  padding: 10px 18px;
  border-radius: 6px;
  border: none;
  background: #1b6b78;
  color: #fff;
  font-size: 0.88rem;
  font-weight: 600;
  cursor: pointer;

  &:hover { background: #175a65; }
`;
